import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React, { useEffect, useReducer, useState } from 'react';
import Pager from "./Pager";
import RowObj from "./RowObj";
import SpinnerApple from "../ui/spinner/Spinner.Apple";
import PropTypes from 'prop-types';
import FeatherIcon from "../ui/feather-icon/FeatherIcon";
import PagerButton from "./PagerButton";
import Spacer from "../ui/spacer/Spacer";
import SimpleCheckbox from "../checkbox/SimpleCheckbox";
import CenteredColumnWidth from "noood/comp/ui/containers/CenteredColumnWidth";
import { __post } from "noood/net/xhr";
import FlexCenter from "noood/comp/ui/containers/flex-boxes/FlexCenter";
import NoRecordsFound from "noood/comp/no-records/NoRecordsFound";
import { string_util } from "noood/util/string/StringUtil";
import { ArrayUtil } from "noood/util/array/ArrayUtil";
import * as stylex from '@stylexjs/stylex';
function paginate(state, action) {
  var _state$data;
  switch (action.type) {
    case 'reset_data':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: undefined
      });
      break;
    case 'init':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: undefined,
        fetching: true
      });
      break;
    case 'exit':
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        data: undefined
      });
      break;
    case 'read':
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
        //data: action.more ? state.data : []
      });
      break;
    case 'unsuccessful':
      return _objectSpread(_objectSpread({}, state), {}, {
        response_message: action.message,
        fetching: false,
        no_data: true
      });
      break;
    case 'success':
      // console.log(`merging`, state.data, ` with `, action.data)
      // console.log(`state.data `, state.data)
      // console.log(`action.data `, action.data)
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.is_table ? action.data : action.more ? [].concat(_toConsumableArray((_state$data = state.data) !== null && _state$data !== void 0 ? _state$data : []), _toConsumableArray(action.data)) : action.data,
        is_end: false,
        no_data: false,
        fetching: false
      });
      break;
    case 'stop':
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false
      });
      break;
    case 'no_data':
      return _objectSpread(_objectSpread({}, state), {}, {
        no_data: true,
        data: [],
        fetching: false
      });
      break;
    case 'end':
      return _objectSpread(_objectSpread({}, state), {}, {
        is_end: true
      });
      break;
  }
}
var initialState = {
  is_load_more: false,
  fetching: false,
  response_message: '',
  data: undefined,
  is_end: false,
  no_data: false
};
export default function InfiniteList(props) {
  var _props$pager, _props$data_table, _props$grid_item_size, _props$grid_item_size2, _props$grid_item_size3, _props$grid_item_size4, _props$grid_item_size5, _props$grid_item_size6, _props$grid_item_size7, _props$grid_item_size8, _props$rows_layout_st, _props$styling;
  //console.log("InfiniteList entry");
  //console.log(`props.pager: ${JSON.stringify(props.pager)}`);

  var _useReducer = useReducer(paginate, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState = useState((_props$pager = props.pager) !== null && _props$pager !== void 0 ? _props$pager : new Pager({
      n: 10
    })),
    _useState2 = _slicedToArray(_useState, 2),
    pager = _useState2[0],
    set_pager = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    result_count = _useState4[0],
    set_result_count = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selected = _useState6[0],
    set_selected = _useState6[1];
  var fetching = state.fetching,
    response_message = state.response_message,
    data = state.data,
    is_end = state.is_end,
    no_data = state.no_data;
  useEffect(function () {
    if (props.pager) {
      var _props$__notify_init;
      dispatch({
        type: 'init'
      });
      (_props$__notify_init = props.__notify_init) === null || _props$__notify_init === void 0 || _props$__notify_init.call(props);
      set_pager(props.pager);
    }
  }, [props.pager]);
  useEffect(function () {
    var encoded_pager = new Pager().set(pager).stringify();
    __read_data(encoded_pager, true);
  }, [pager]);
  useEffect(function () {
    return function () {
      dispatch({
        type: 'exit'
      });
    };
  }, []);
  function __load_more() {
    if (!fetching) {
      __get_data(true);
    }
  }
  function __read_data(the_pager, is_load_more) {
    dispatch({
      type: 'read',
      more: is_load_more
    });
    __post("".concat(props.uri), {
      base_url: '',
      body: JSON.stringify({
        pager: the_pager
      })
    }, function (res) {
      var _res$http, _res$http2, _res$http3, _res$http4;
      if (((_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200) {
        if (res.data) {
          if (!res.data.result_count) {
            var _props$__get_list;
            dispatch({
              type: 'no_data'
            });
            (_props$__get_list = props.__get_list) === null || _props$__get_list === void 0 || _props$__get_list.call(props, []);
          } else {
            var _res$data, _data$length;
            set_result_count(res.data.result_count);
            if (((_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.list) === null || _res$data === void 0 ? void 0 : _res$data.length) > 0) {
              var _props$__get_list2;
              dispatch({
                type: 'success',
                more: is_load_more,
                data: res.data.list,
                is_table: props.data_table
              });
              (_props$__get_list2 = props.__get_list) === null || _props$__get_list2 === void 0 || _props$__get_list2.call(props, res.data.list);
            } else {
              dispatch({
                type: 'end',
                load_more: is_load_more
              });
            }
            // console.log(`data: `, data)
            if (res.data.result_count === ((_data$length = data === null || data === void 0 ? void 0 : data.length) !== null && _data$length !== void 0 ? _data$length : 0) + res.data.list.length) {
              dispatch({
                type: 'end'
              });
            }
          }
        } else {
          var _props$__get_list3;
          // set_response_message('No records found.');
          (_props$__get_list3 = props.__get_list) === null || _props$__get_list3 === void 0 || _props$__get_list3.call(props, []);
          dispatch({
            type: 'no_data'
          });
        }
      } else if (((_res$http2 = res.http) === null || _res$http2 === void 0 ? void 0 : _res$http2.code) === 404) {
        dispatch({
          type: 'unsuccessful',
          message: "Failed to fetch data."
        });
      } else if (((_res$http3 = res.http) === null || _res$http3 === void 0 ? void 0 : _res$http3.code) === 401) {
        dispatch({
          type: 'unsuccessful',
          message: "Failed to fetch data."
        });
      } else if (((_res$http4 = res.http) === null || _res$http4 === void 0 ? void 0 : _res$http4.code) === 400) {
        dispatch({
          type: 'unsuccessful',
          message: "Failed to fetch data."
        });
      }
    });
  }
  function __get_data(is_load_more) {
    // console.log("load more? ", is_load_more);
    dispatch({
      type: 'read'
    });
    var the_pager = null;
    if (is_load_more) {
      var updated_pager = new Pager().set(pager);
      updated_pager.next_page();
      set_pager(updated_pager);
      the_pager = updated_pager.stringify();
      // console.log('the_pager', the_pager)
    } else {
      the_pager = new Pager().set(props.pager).stringify();
    }
    //__read_data(the_pager, is_load_more);
  }
  var page_count = Math.ceil(result_count / pager.n);
  var has_next = pager.x < page_count;
  var has_prev = pager.x > 1;
  var _selfAdjust = function _selfAdjust(evt) {
    console.log(evt);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (data === null || data === void 0 ? void 0 : data.length) > 0 && ((_props$data_table = props.data_table) === null || _props$data_table === void 0 || (_props$data_table = _props$data_table.cols) === null || _props$data_table === void 0 ? void 0 : _props$data_table.length) > 0 && !no_data ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onLoadCapture: function onLoadCapture(e) {
      _selfAdjust(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      border: "0px dotted red"
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "InfiniteList__ui.table ev1mwwwfo evh8yej3"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "InfiniteList__ui.header ev1kd3s2o"
  }, props.data_table.selectable && /*#__PURE__*/React.createElement("th", {
    style: {
      width: "15px"
    }
  }, /*#__PURE__*/React.createElement(SimpleCheckbox, {
    __collect: function __collect(checked) {
      if (checked) {
        // select all records below
      }
    }
  })), props.data_table.cols.map(function (col, idx) {
    var _col$label, _col$property;
    var header_style = {
      width: "".concat(col.width ? col.width : 300, "px")
    };
    if (col.flush_right_title) {
      header_style.textAlign = "right";
    }
    return /*#__PURE__*/React.createElement("th", _extends({
      style: header_style,
      key: idx
    }, {
      className: "InfiniteList__ui.header_cell ev4z9k3i ev1dow0g4 evdpxx8g evo1l8bm"
    }), (_col$label = col.label) !== null && _col$label !== void 0 ? _col$label : string_util.uc_words((_col$property = col.property) !== null && _col$property !== void 0 ? _col$property : '', '_'));
  }))), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row, rowIdx) {
    return /*#__PURE__*/React.createElement("tr", {
      key: rowIdx
    }, props.data_table.selectable && /*#__PURE__*/React.createElement("td", {
      style: {
        verticalAlign: "top"
      }
    }, /*#__PURE__*/React.createElement(SimpleCheckbox, null)), props.data_table.cols.map(function (col, idx) {
      var _col$property2, _row$col$property$spl, _col$property$split, _col$property3;
      var cell_style = {
        width: "".concat(col.width ? col.width : 300, "px")
      };
      if (col.content && col.flush_right) {
        cell_style.textAlign = 'right';
      }
      return /*#__PURE__*/React.createElement("td", _extends({
        key: "cell-".concat(idx),
        style: cell_style
      }, stylex.props(ui.cell, rowIdx % 2 !== 0 && ui.cell_odd, rowIdx === (data === null || data === void 0 ? void 0 : data.length) - 1 && ui.last_row_cell)), col.content ? /*#__PURE__*/React.createElement(React.Fragment, null, col.content(row)) : ((_col$property2 = col.property) === null || _col$property2 === void 0 || (_col$property2 = _col$property2.split("\.")) === null || _col$property2 === void 0 ? void 0 : _col$property2.length) === 2 ? (_row$col$property$spl = row[(_col$property$split = col.property.split(".")) === null || _col$property$split === void 0 ? void 0 : _col$property$split[0]]) === null || _row$col$property$spl === void 0 ? void 0 : _row$col$property$spl[(_col$property3 = col.property) === null || _col$property3 === void 0 || (_col$property3 = _col$property3.split(".")) === null || _col$property3 === void 0 ? void 0 : _col$property3[1]] : /*#__PURE__*/React.createElement(React.Fragment, null, row[col.property]));
    }));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "InfiniteList__ui.tableControls ev78zum5 ev1qughib evfifm61 ev178dk4m ev1ghz6dp ev7z7khe ev6s0dn4 ev1y7ric0 ev1hjqwhg"
  }, /*#__PURE__*/React.createElement("div", null, pager.x * pager.n - pager.n + 1, "-", result_count < pager.x * pager.n ? result_count : pager.x * pager.n, " / ", result_count, "\xA0 ", /*#__PURE__*/React.createElement(FeatherIcon, {
    style: {
      fontSize: '12px'
    },
    icon: 'settings'
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "5px"
    }
  }, Math.ceil(result_count / pager.n), " Page", Math.ceil(result_count / pager.n) > 1 ? 's' : ''), /*#__PURE__*/React.createElement(PagerButton, {
    isFirst: true,
    active: has_prev && !fetching,
    __click: function __click() {
      dispatch({
        type: 'read',
        is_table: props.data_table
      });
      var new_pager = _objectSpread(_objectSpread({}, pager), {}, {
        x: 1
      });
      set_pager(new_pager);
    },
    icon: 'chevrons-left'
  }), /*#__PURE__*/React.createElement(PagerButton, {
    active: has_prev && !fetching,
    __click: function __click() {
      dispatch({
        type: 'read',
        is_table: props.data_table
      });
      var new_pager = _objectSpread(_objectSpread({}, pager), {}, {
        x: Number(pager.x) - 1
      });
      set_pager(new_pager);
    },
    icon: 'chevron-left'
  }), Array(3).fill(0).map(function (i, idx) {
    var page = pager.x - 5 + idx;
    if (page > 0) {
      return /*#__PURE__*/React.createElement("span", _extends({}, {
        className: "InfiniteList__ui.pageLink ev1ypdohk ev78zum5 ev6s0dn4 evezl2tj evl56j7k ev1qx5ct2 ev1xqaldw evji57aj ev6nv2ps"
      }, {
        key: idx,
        onClick: function onClick() {
          if (!fetching) {
            dispatch({
              type: 'read',
              is_table: props.data_table
            });
            var new_pager = _objectSpread(_objectSpread({}, pager), {}, {
              x: page
            });
            set_pager(new_pager);
          }
        }
      }), page);
    }
  }), fetching ? /*#__PURE__*/React.createElement("span", {
    className: "InfiniteList__ui.pageLinkSpinner ev1bkuceq ev78zum5 ev6s0dn4 ev1qx5ct2 evezl2tj evl56j7k"
  }, /*#__PURE__*/React.createElement(SpinnerApple, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({}, {
    className: "InfiniteList__ui.currentPageInput ev10a8zc3 ev3kkplk ev1bkuceq ev4z9k3i evxzb6uj evezl2tj ev1qx5ct2 ev2b8uid"
  }, {
    value: pager.x,
    onChange: function onChange() {}
  }))), pager.x < page_count && /*#__PURE__*/React.createElement(React.Fragment, null, Array(3).fill(0).map(function (i, idx) {
    var page = idx + Number(pager.x) + 1;
    if (page <= page_count) {
      return /*#__PURE__*/React.createElement("span", _extends({}, {
        className: "InfiniteList__ui.pageLink ev1ypdohk ev78zum5 ev6s0dn4 evezl2tj evl56j7k ev1qx5ct2 ev1xqaldw evji57aj ev6nv2ps"
      }, {
        key: idx,
        onClick: function onClick() {
          if (!fetching) {
            dispatch({
              type: 'read',
              is_table: props.data_table
            });
            var new_pager = _objectSpread(_objectSpread({}, pager), {}, {
              x: page
            });
            set_pager(new_pager);
          }
        }
      }), page);
    }
  })), /*#__PURE__*/React.createElement(PagerButton, {
    active: has_next && !fetching,
    __click: function __click() {
      dispatch({
        type: 'read',
        is_table: props.data_table
      });
      var new_pager = _objectSpread(_objectSpread({}, pager), {}, {
        x: Number(pager.x) + 1
      });
      set_pager(new_pager);
    },
    icon: 'chevron-right'
  }), /*#__PURE__*/React.createElement(PagerButton, {
    active: has_next && !fetching,
    isLast: true,
    __click: function __click() {
      dispatch({
        type: 'read',
        is_table: props.data_table
      });
      var new_pager = _objectSpread(_objectSpread({}, pager), {}, {
        x: page_count
      });
      set_pager(new_pager);
    },
    icon: 'chevrons-right'
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, no_data && !fetching ? /*#__PURE__*/React.createElement(React.Fragment, null, props.grid ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'ui-data-grid-no-data',
    style: {
      border: '1px dashed #ccc',
      width: (_props$grid_item_size = props.grid_item_size) !== null && _props$grid_item_size !== void 0 && _props$grid_item_size.width ? "".concat((_props$grid_item_size2 = props.grid_item_size) === null || _props$grid_item_size2 === void 0 ? void 0 : _props$grid_item_size2.width, "px") : '150px',
      height: (_props$grid_item_size3 = props.grid_item_size) !== null && _props$grid_item_size3 !== void 0 && _props$grid_item_size3.height ? "".concat((_props$grid_item_size4 = props.grid_item_size) === null || _props$grid_item_size4 === void 0 ? void 0 : _props$grid_item_size4.height, "px") : '150px'
    }
  }, "End")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 30
  }), /*#__PURE__*/React.createElement("div", {
    className: props.grid ? 'grid-no-data' : 'flex-center',
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(FlexCenter, null, /*#__PURE__*/React.createElement("span", {
    className: "text-negative"
  }, response_message), (data === null || data === void 0 ? void 0 : data.length) === 0 && /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, "No records found."))))) : /*#__PURE__*/React.createElement(React.Fragment, null, props.data_table && /*#__PURE__*/React.createElement(React.Fragment, null, data === void 0 && /*#__PURE__*/React.createElement(FlexCenter, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 50
  }), /*#__PURE__*/React.createElement(SpinnerApple, null)), data !== void 0 && (data === null || data === void 0 ? void 0 : data.length) === 0 && /*#__PURE__*/React.createElement(NoRecordsFound, null)), data !== void 0 && data !== null && data.length === 0 && /*#__PURE__*/React.createElement(NoRecordsFound, {
    message: "There are no builds yet.",
    caption: ''
  }))), response_message && /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 300
  }, response_message), props.grid ? /*#__PURE__*/React.createElement(React.Fragment, null, data.map(function (obj, idx) {
    return props.row(obj, idx);
  }), !fetching ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (data.length < result_count) {
        __load_more();
      }
    },
    style: {
      width: (_props$grid_item_size5 = props.grid_item_size) !== null && _props$grid_item_size5 !== void 0 && _props$grid_item_size5.width ? "".concat((_props$grid_item_size6 = props.grid_item_size) === null || _props$grid_item_size6 === void 0 ? void 0 : _props$grid_item_size6.width, "px") : '150px',
      height: (_props$grid_item_size7 = props.grid_item_size) !== null && _props$grid_item_size7 !== void 0 && _props$grid_item_size7.height ? "".concat((_props$grid_item_size8 = props.grid_item_size) === null || _props$grid_item_size8 === void 0 ? void 0 : _props$grid_item_size8.height, "px") : '150px'
    },
    className: ['flex-center-center', data.length < result_count ? 'ui-data-grid-load-more' : 'ui-data-grid-no-load-more'].join(' ')
  }, data.length, " of ", result_count, " ", /*#__PURE__*/React.createElement("br", null), data.length >= result_count ? null : /*#__PURE__*/React.createElement("div", null, "Load More"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SpinnerApple, null))) : /*#__PURE__*/React.createElement(React.Fragment, null, ArrayUtil.hasElts(data) && !props.data_table > 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    style: (_props$rows_layout_st = props.rows_layout_style) !== null && _props$rows_layout_st !== void 0 ? _props$rows_layout_st : {}
  }, {
    className: "InfiniteList__ui.row ev1n3r610"
  }), data.map(function (obj, idx) {
    return /*#__PURE__*/React.createElement(RowObj, {
      key: idx,
      row: props.row(obj, idx),
      grid: props.grid
    });
  })), /*#__PURE__*/React.createElement("div", _extends({
    onClick: function onClick() {
      if (!fetching && !is_end) {
        __load_more();
      }
    }
  }, stylex.props(props.stylex.pager_container)), /*#__PURE__*/React.createElement("div", _extends({
    style: _objectSpread({
      position: "absolute"
    }, (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.counter)
  }, {
    className: "InfiniteList__ui.n_of_n ev1blgh98 ev16ydxro ev10l6tqk ev1anpbxc"
  }), data.length, " of ", result_count), /*#__PURE__*/React.createElement("div", stylex.props(ui.load_more, fetching && ui.is_fetching, is_end && ui.is_end), fetching ? /*#__PURE__*/React.createElement(SpinnerApple, {
    strokeSize: 1.5,
    size: 20
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, is_end ? 'End' : 'Load More')))) : /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%"
    }
  }, fetching && !props.data_table ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      paddingTop: 50
    }
  }, /*#__PURE__*/React.createElement(SpinnerApple, {
    size: 20
  })) : data && Array.isArray(data) && data.length === 0 && !props.data_table && /*#__PURE__*/React.createElement(FlexCenter, null, /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, "No records found.")))));
}
InfiniteList.propTypes = {
  __get_list: PropTypes.func,
  __notify_init: PropTypes.func,
  pager: PropTypes.object,
  uri: PropTypes.string,
  row: PropTypes.func,
  grid: PropTypes.bool,
  rows_layout_style: PropTypes.object,
  data_table: PropTypes.shape({
    selectable: PropTypes.bool,
    cols: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      property: PropTypes.string,
      content: PropTypes.func,
      width: PropTypes.number,
      flush_right: PropTypes.bool,
      flush_right_title: PropTypes.bool
    }))
  }),
  grid_item_size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  showInfiniteListSetting: PropTypes.bool,
  styling: PropTypes.shape({
    counter: PropTypes.object
  }),
  stylex: PropTypes.shape({
    pager_container: PropTypes.object
  })
};
InfiniteList.defaultProps = {
  showInfiniteListSetting: true
};
_inject(".ev10a8zc3{background-color:var(--shade-darker)}", 3000);
_inject(".ev3kkplk{color:var(--shade-90)}", 3000);
_inject(".ev1bkuceq{border:1px solid var(--shade-20)}", 1000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".evxzb6uj{padding:2px 4px}", 1000);
_inject(".evezl2tj{width:25px}", 4000);
_inject(".ev1qx5ct2{height:20px}", 4000);
_inject(".ev2b8uid{text-align:center}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev1xqaldw{border:0 solid var(--shade-20)}", 1000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev6nv2ps:hover{background-color:var(--shade-20)}", 3130);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1kd3s2o{background-color:var(--shade-20)}", 3000);
_inject(".ev1dow0g4{padding:7px 5px}", 1000);
_inject(".evdpxx8g{text-align:left}", 3000);
_inject(".evo1l8bm{font-weight:400}", 3000);
_inject(".ev1mwwwfo{border-collapse:collapse}", 3000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".evhouosl{padding:8px 8px 8px 5px}", 1000);
_inject(".evz7ivw7{border-bottom:1px solid var(--shade-10)}", 2000);
_inject(".ev1qughib{justify-content:space-between}", 3000);
_inject(".evfifm61{font-size:12px}", 3000);
_inject(".ev178dk4m{color:#7c7c7c}", 3000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev7z7khe{padding:10px}", 1000);
_inject(".ev1hjqwhg{border-top:1px solid var(--shade-10)}", 2000);
_inject(".ev1n2onr6{position:relative}", 3000);
_inject(".ev1h6gzvc{cursor:not-allowed}", 3000);
_inject(".ev1blgh98{color:var(--shade-40)}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".evu96u03{left:0}", 4000);
_inject(".ev10l6tqk{position:absolute}", 3000);
_inject(".ev1lqa7cf{padding-left:10px}", 4000);
_inject(".ev1n3r610:last-of-type{border-bottom:1px solid red}", 2055);
_inject(".evaqea5y{border-bottom:0}", 2000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev12p33jh:active{background-color:var(--shade-15)}", 3170);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1qjc9v5{align-items:stretch}", 3000);
_inject(".ev16kvzi7{border-radius:var(--more-roundness)}", 2000);
_inject(".ev5ea3kt{color:var(--shade-70)}", 3000);
_inject(".ev16ydxro{margin-left:10px}", 4000);
_inject(".ev1anpbxc{margin-top:10px}", 4000);
_inject(".ev1jo8pe8{color:var(--shade-30)}", 3000);
var ui = {
  cell_odd: {
    "InfiniteList__ui.cell_odd": "InfiniteList__ui.cell_odd",
    backgroundColor: "ev1y7ric0",
    $$css: true
  },
  cell: {
    "InfiniteList__ui.cell": "InfiniteList__ui.cell",
    padding: "evhouosl",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "ev1y7ric0",
    borderBottom: "evz7ivw7",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    $$css: true
  },
  last_row_cell: {
    "InfiniteList__ui.last_row_cell": "InfiniteList__ui.last_row_cell",
    borderBottom: "evaqea5y",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    $$css: true
  },
  load_more: {
    "InfiniteList__ui.load_more": "InfiniteList__ui.load_more",
    backgroundColor: "ev1y7ric0 ev3dtjww ev12p33jh",
    cursor: "ev1ypdohk",
    transition: "ev1h2kqdt",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    padding: "ev7z7khe",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "ev78zum5",
    alignItems: "ev1qjc9v5",
    justifyContent: "evl56j7k",
    position: "ev1n2onr6",
    borderRadius: "ev16kvzi7",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    color: "ev5ea3kt",
    $$css: true
  },
  is_fetching: {
    "InfiniteList__ui.is_fetching": "InfiniteList__ui.is_fetching",
    backgroundColor: "ev1y7ric0",
    cursor: "ev1h6gzvc",
    $$css: true
  },
  is_end: {
    "InfiniteList__ui.is_end": "InfiniteList__ui.is_end",
    backgroundColor: "ev1y7ric0",
    cursor: "ev1h6gzvc",
    color: "ev1jo8pe8",
    $$css: true
  }
};